import { useState } from "react";
import { api } from "@/lib/api";

export default function SettingsModal({ open, onClose, username, onUpdated }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newUsername, setNewUsername] = useState(username || "");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    if (newPassword && newPassword !== confirmPassword) {
      setError("كلمتا المرور الجديدتان غير متطابقتين");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/auth/change-credentials", {
        current_password: currentPassword,
        new_username: newUsername,
        new_password: newPassword || null,
      });
      setSuccess(res.data.message || "تم التحديث بنجاح");
      onUpdated(res.data.token, res.data.username);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        setSuccess(null);
        onClose();
      }, 1600);
    } catch (err) {
      setError(err?.response?.data?.detail || "تعذر التحديث");
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="settings-modal">
      <div className="modal-box" onClick={(e) => e.stopPropagation()} dir="rtl">
        <div className="modal-head">
          <h3>⚙️ إعدادات الحساب</h3>
          <button className="modal-close" onClick={onClose} data-testid="settings-close-btn">✕</button>
        </div>
        <p className="modal-sub">غيّر اسم المستخدم أو كلمة المرور — كلمة المرور الحالية مطلوبة للتأكيد</p>

        <form onSubmit={submit} className="login-form">
          <label className="field-label">كلمة المرور الحالية *</label>
          <input
            className="field-input"
            dir="ltr"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            data-testid="settings-current-password"
          />

          <label className="field-label">اسم المستخدم الجديد</label>
          <input
            className="field-input"
            dir="ltr"
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
            data-testid="settings-new-username"
          />

          <label className="field-label">كلمة المرور الجديدة (اتركها فارغة للإبقاء على الحالية)</label>
          <input
            className="field-input"
            dir="ltr"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            data-testid="settings-new-password"
          />

          {newPassword && (
            <>
              <label className="field-label">تأكيد كلمة المرور الجديدة</label>
              <input
                className="field-input"
                dir="ltr"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                data-testid="settings-confirm-password"
              />
            </>
          )}

          {error && <div className="login-error" data-testid="settings-error">✖ {error}</div>}
          {success && <div className="settings-success" data-testid="settings-success">✔ {success}</div>}

          <button className="btn btn-primary login-btn" type="submit" disabled={loading} data-testid="settings-submit-btn">
            {loading ? "جاري الحفظ..." : "حفظ التغييرات"}
          </button>
        </form>
      </div>
    </div>
  );
}
